import { useEffect, useState } from "react";
import { gameApi } from "@/lib/api";
import { toast } from "sonner";
import { Loader2, ArrowUp, ArrowDown } from "lucide-react";
import { MENU_ITEMS } from "@/components/game/GameNav";

export const MenuAdmin = () => {
  const [order, setOrder] = useState(null);
  const [busy, setBusy] = useState(false);
  const labelOf = (id) => MENU_ITEMS.find((m) => m.id === id)?.label || id;
  useEffect(() => {
    gameApi.get("/game/menu-config").then((r) => setOrder(r.data.order)).catch(() => setOrder(MENU_ITEMS.map((m) => m.id)));
  }, []);
  const move = (i, d) => {
    const j = i + d;
    if (j < 0 || j >= order.length) return;
    const n = [...order];
    [n[i], n[j]] = [n[j], n[i]];
    setOrder(n);
  };
  const save = async () => {
    setBusy(true);
    try { await gameApi.post("/game/admin/menu-config", { order }); toast.success("Menu order saved for all players"); }
    catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
    finally { setBusy(false); }
  };
  if (!order) return <p className="mt-6 flex items-center justify-center gap-2 text-sm text-muted-foreground"><Loader2 className="animate-spin" size={16} /> Loading…</p>;
  return (
    <div className="mt-3 space-y-2" data-testid="admin-menu">
      <p className="text-xs text-muted-foreground">Reorder the sidebar menu with the arrows, then Save. This order applies to every player.</p>
      {order.map((id, i) => (
        <div key={id} data-testid={`menu-row-${id}`} className="flex items-center gap-2 rounded-xl border border-border bg-card px-3 py-2">
          <span className="grid h-6 w-6 place-items-center rounded-full bg-muted text-[11px] font-bold text-muted-foreground">{i + 1}</span>
          <span className="flex-1 text-sm font-semibold text-primary">{labelOf(id)}</span>
          <button data-testid={`menu-up-${id}`} disabled={i === 0} onClick={() => move(i, -1)} className="rounded-lg border border-border p-1.5 disabled:opacity-30"><ArrowUp size={14} /></button>
          <button data-testid={`menu-down-${id}`} disabled={i === order.length - 1} onClick={() => move(i, 1)} className="rounded-lg border border-border p-1.5 disabled:opacity-30"><ArrowDown size={14} /></button>
        </div>
      ))}
      <button data-testid="menu-save" disabled={busy} onClick={save} className="mt-2 w-full rounded-xl bg-primary py-2.5 text-sm font-bold text-primary-foreground disabled:opacity-50">{busy ? "Saving…" : "Save Menu Order"}</button>
    </div>
  );
};
